export default function StatusBadge({ status }) {
  const map = {
    success: { bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200", label: "Success" },
    failed: { bg: "bg-red-50", text: "text-red-700", border: "border-red-200", label: "Failed" },
    pending: { bg: "bg-amber-50", text: "text-amber-800", border: "border-amber-200", label: "Pending" },
    skipped: { bg: "bg-neutral-100", text: "text-neutral-600", border: "border-neutral-300", label: "Skipped" },
    active: { bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200", label: "Active" },
    paused: { bg: "bg-neutral-100", text: "text-neutral-600", border: "border-neutral-200", label: "Paused" },
  };
  const s = map[status] || map.pending;
  return (
    <span
      data-testid={`status-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${s.bg} ${s.text} ${s.border}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${s.text.replace("text-", "bg-")}`} />
      {s.label}
    </span>
  );
}
